(ns frontend.view.settings2.zap-vaults.model
  (:require [clojure.string :as string]))

(def root-path [::state])

(def active-tab-key :active-tab)
(def active-tab-full-path (into root-path [active-tab-key]))

(def button-color-key :button-color)
(def button-color-full-path (into root-path [button-color-key]))

(def text-color-key :text-color)
(def text-color-full-path (into root-path [text-color-key]))

(def back-url-key :back-url)
(def back-url-full-path (into root-path [back-url-key]))

(def back-url-editable?-key :back-url-editable?)
(def back-url-editable?-full-path (into root-path [back-url-editable?-key]))

(def unauthorized-message-key :unauthorized-message)
(def unauthorized-message-full-path (into root-path [unauthorized-message-key]))

(def unauthorized-message-editable?-key :unauthorized-message-editable?)
(def unauthorized-message-editable?-full-path (into root-path [unauthorized-message-editable?-key]))

(def disclaimer-message-key :disclaimer-message)
(def disclaimer-message-full-path (into root-path [disclaimer-message-key]))

(def disclaimer-confirm-text-key :disclaimer-confirm-text)
(def disclaimer-confirm-text-full-path (into root-path [disclaimer-confirm-text-key]))

(def disclaimer-message-editable?-key :disclaimer-message-editable?)
(def disclaimer-message-editable?-full-path (into root-path [disclaimer-message-editable?-key]))

(def members-editable?-key :members-editable?)
(def members-editable?-full-path (into root-path [members-editable?-key]))

(def teams-editable?-key :teams-editable?)
(def teams-editable?-full-path (into root-path [teams-editable?-key]))

(def logo-key :logo)
(def logo-full-path (into root-path [logo-key]))

(def uploading-logo-key :uploading-logo?)
(def uploading-logo-full-path (into root-path [uploading-logo-key]))

(def saving?-key :saving?)
(def saving?-full-path (into root-path [saving?-key]))

(def field-key-mappings
  {:vault-config/vault-logo                               logo-key
   :vault-config/text-color                               text-color-key
   :vault-config/button-color                             button-color-key
   :vault-config/logout-url                               back-url-key
   :vault-config/allow-url-modification?                  back-url-editable?-key
   :vault-config/no-access-message                        unauthorized-message-key
   :vault-config/allow-unauthorized-message-modification? unauthorized-message-editable?-key
   :vault-config/disclaimer-message                       disclaimer-message-key
   :vault-config/disclaimer-confirm-text                  disclaimer-confirm-text-key
   :vault-config/allow-disclaimer-modification?           disclaimer-message-editable?-key
   :vault-config/allow-members-configuration?             members-editable?-key
   :vault-config/allow-teams-configuration?               teams-editable?-key})

(defn unsaved-changes
  [state default-config]
  (->> field-key-mappings
       (keep (fn [[k mk]]
               (let [original-value (get default-config k "")
                     modified-value (get state mk)]
                 (when-not (nil? modified-value)
                   (when-not (= modified-value original-value)
                     (if (and (string? modified-value)
                              (= (string/replace modified-value #"&nbsp;" " ")
                                 (string/replace original-value #" " " ")))
                       (println "NOT SAME Ignore:" modified-value "\n" (get default-config k))
                       [k modified-value]))))))
       (seq)
       (into {})))
